import { render, staticRenderFns } from "./RISK.vue?vue&type=template&id=a5f77324&"
import script from "./RISK.vue?vue&type=script&lang=js&"
export * from "./RISK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports